<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="firmware,firmwares"
    icon="mdi-tablet-dashboard"
    :value="value"
    @input="(v) => $emit('input', v)"
    types="grouped-items"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { Firmware } from '@/models'
import { orderBy, atMost } from 'oderon-commons/src/utils'
import { toHex } from '../../utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Firmware' },
    orientation: { type: String, default: 'horizontal' },
    value: {},
    useVersionAsId: {type: Boolean, default: false}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = await Firmware.findAll()
      // rows = rows.filter(r => r.id != -1 && hasTag(r.extraInfo, 'PRD'))
      rows = rows.map((r) => {
        let s = `0x${toHex(r.version)} - ${r.name}`
        let id = r.id
        if ( this.useVersionAsId ) id = r.version
        return { id, name: atMost(s, 80), version: r.version }
      })
      this.allItems = orderBy(rows, [['version', 'desc']])
    }
  }
}
</script>

<style></style>
